export const Utils = {
  toWebpName(file: File): string {
    return file.name.replace(/\.\w+$/, '.webp');
  },

  resizeAndConvertToWebp(file: File, maxResolution = 720, quality = 0.75): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = () => {
        const { width: origW, height: origH } = img;
        const maxSide = Math.max(origW, origH);
        const ratio = maxSide > maxResolution ? maxResolution / maxSide : 1;
        const newW = Math.round(origW * ratio);
        const newH = Math.round(origH * ratio);

        const canvas = document.createElement('canvas');
        canvas.width = newW;
        canvas.height = newH;
        canvas.getContext('2d')!.drawImage(img, 0, 0, newW, newH);

        URL.revokeObjectURL(url);
        canvas.toBlob(
          blob => blob ? resolve(blob) : reject(new Error('Falha ao converter para WebP')),
          'image/webp',
          quality
        );
      };

      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Falha ao carregar imagem')); };
      img.src = url;
    });
  },
  formatPrice(price: number): string | null {
    if(price)
       return `${price} €`;

    return null;
  },

  formatDate(date: Date | string): string {
    const parsedDate = new Date(date);
    return parsedDate.toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  },

  formatMonth(date: Date | string): string {
    const parsedDate = new Date(date);
    return parsedDate.toLocaleDateString('pt-PT', {
      month: 'long',
      year: 'numeric'
    });
  },

  formatImg(url: string): string {
    if(url.startsWith('https'))
      return url;

    return `/images/${url}`;
  }
}
